<!--
 * @Descripttion:
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2021-11-08 19:17:40
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2023-04-06 18:00:19
-->
<template>
  <div class="index-partner wh100">
    <div class="container wh100">
      <div :class="['index-partner-title', realIndex === activeIndex ? 'transition' : '']">
        <div class="ui-title p-t-10">{{ $t('frontPage.partner.title') }}</div>
        <div class="ui-des">{{ $t('frontPage.partner.des') }}</div>
      </div>
      <!-- <div :class="['clearfix index-partner-type', realIndex === activeIndex ? 'transition' : '']">
        <div class="fl index-partner-type-item left" @mouseenter="mouseenter('heart')" @mouseleave="mouseleave">
          <img class="index-partner-type-img img1" :src="require('@/assets/images/index/partner/heart1.png')" alt="" srcset="">
          <img class="index-partner-type-img img2" :src="require('@/assets/images/index/partner/heart2.png')" alt="" srcset="">
          <div class="flex justify_content_center flex_col hei100 posrel">
            <div :class="['index-partner-type-title center_left_right', language == 'en' ? 'en' : '']">{{ $t('frontPage.partner.heart.title') }}</div>
            <div v-if="language != 'en'">{{ $t('frontPage.partner.heart.des') }}</div>
          </div>
        </div>
        <div class="fl index-partner-type-item right" @mouseenter="mouseenter('skull')" @mouseleave="mouseleave">
          <img class="index-partner-type-img img1" :src="require('@/assets/images/index/partner/skull1.png')" alt="" srcset="">
          <img class="index-partner-type-img img2" :src="require('@/assets/images/index/partner/skull2.png')" alt="" srcset="">
          <div class="flex justify_content_center flex_col hei100 posrel">
            <div :class="['index-partner-type-title center_left_right', language == 'en' ? 'en nowrap' : '']">{{ $t('frontPage.partner.skull.title') }}</div>
            <div v-if="language != 'en'">{{ $t('frontPage.partner.skull.des') }}</div>
          </div>
        </div>
      </div> -->
      <div :class="['clearfix index-partner-type', realIndex === activeIndex ? 'transition' : '']">
        <div class="fl index-partner-type-item left" @mouseenter="mouseenter('skull')" @mouseleave="mouseleave">
          <img class="index-partner-type-img img1" :src="require('@/assets/images/index/partner/skull1.png')" alt="" srcset="">
          <img class="index-partner-type-img img2" :src="require('@/assets/images/index/partner/skull2.png')" alt="" srcset="">
          <div class="flex justify_content_center flex_col hei100 posrel">
            <div :class="['index-partner-type-title center_left_right', language == 'en' ? 'en nowrap' : '']">{{ $t('frontPage.partner.skull.title') }}</div>
            <div v-if="language != 'en'">{{ $t('frontPage.partner.skull.des') }}</div>
          </div>
        </div>
        <div class="fl index-partner-type-item right" @mouseenter="mouseenter('heart')" @mouseleave="mouseleave">
          <img class="index-partner-type-img img1" :src="require('@/assets/images/index/partner/heart1.png')" alt="" srcset="">
          <img class="index-partner-type-img img2" :src="require('@/assets/images/index/partner/heart2.png')" alt="" srcset="">
          <div class="flex justify_content_center flex_col hei100 posrel">
            <div :class="['index-partner-type-title center_left_right', language == 'en' ? 'en' : '']">{{ $t('frontPage.partner.heart.title') }}</div>
            <div v-if="language != 'en'">{{ $t('frontPage.partner.heart.des') }}</div>
          </div>
        </div>
      </div>
      <div id="indexPartner" :class="['swiper overhid index-partner-swiper m-t-20 posrel', realIndex === activeIndex ? 'transition' : '']">
        <template v-if="language == 'en'">
          <div class="swiper-wrapper" @mouseenter="mouseenterImg()" @mouseleave="mouseleaveImg">
            <div class="swiper-slide index-partner-slide clearfix" v-for="(item, index) in 3" :key="index">
              <div class="index-partner-slide-item fl">
                <div class="index-partner-slide-img ilblk posrel" v-for="($item, $index) in 4" :key="$index"><img class="center_up_down_left_right" :data-src1="require(`@/assets/images/index/partner/en/skull_${index * 4 + $index + 1}.png`)" :data-src2="require(`@/assets/images/index/partner/en/skull_${index * 4 + $index + 1}_bj.png`)" :src="require(`@/assets/images/index/partner/en/skull_${index * 4 + $index + 1}.png`)" alt="" srcset=""></div>
              </div>
              <div class="index-partner-slide-item fl">
                <div class="index-partner-slide-img ilblk posrel" v-for="($item, $index) in 4" :key="$index"><img class="center_up_down_left_right" :data-src1="require(`@/assets/images/index/partner/en/heart_${index * 4 + $index + 1}.png`)" :data-src2="require(`@/assets/images/index/partner/en/heart_${index * 4 + $index + 1}_bj.png`)" :src="require(`@/assets/images/index/partner/en/heart_${index * 4 + $index + 1}.png`)" alt="" srcset=""></div>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="swiper-wrapper" @mouseenter="mouseenterImg()" @mouseleave="mouseleaveImg">
            <div class="swiper-slide index-partner-slide clearfix" v-for="(item, index) in 5" :key="index">
              <div class="index-partner-slide-item fl">
                <div class="index-partner-slide-img ilblk posrel" v-for="($item, $index) in 4" :key="$index"><img class="center_up_down_left_right" :style="index == 2 && $index == 3 ? 'width: 65%;' : ''" :data-src1="require(`@/assets/images/index/partner/skull_${index * 4 + $index + 1}.png`)" :data-src2="require(`@/assets/images/index/partner/skull_${index * 4 + $index + 1}_bj.png`)" :src="require(`@/assets/images/index/partner/skull_${index * 4 + $index + 1}.png`)" alt="" srcset=""></div>
              </div>
              <div class="index-partner-slide-item fl">
                <div class="index-partner-slide-img ilblk posrel" v-for="($item, $index) in 4" :key="$index"><img class="center_up_down_left_right" :data-src1="require(`@/assets/images/index/partner/heart_${index * 4 + $index + 1}.png`)" :data-src2="require(`@/assets/images/index/partner/heart_${index * 4 + $index + 1}_bj.png`)" :src="require(`@/assets/images/index/partner/heart_${index * 4 + $index + 1}.png`)" alt="" srcset=""></div>
              </div>
            </div>
          </div>
        </template>
      </div>
      <div class="swiper-pagination index-partner-pagination"></div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    realIndex: {
      type: Number,
      default: 0
    },
    activeIndex: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      mySwiper: null,
      active: null
    }
  },
  computed: {
    ...mapGetters(['language'])
  },
  watch: {
    realIndex (newV, oldV) {
      if (newV === this.activeIndex) {
        this.mySwiper && this.mySwiper.autoplay.start()
      } else {
        this.mySwiper && this.mySwiper.autoplay.stop()
      }
    }
  },
  mounted () {
    this.mySwiper = new this.$Swiper('#indexPartner', {
      loop: true,
      // autoplay: {
      //   delay: 2000,
      //   disableOnInteraction: false
      // },
      pagination: {
        el: '.index-partner-pagination',
        bulletElement: 'li',
        clickable: true
      }
    })
  },
  methods: {
    mouseenter (type) {
      this.active = type
      const partner = document.getElementsByClassName('index-partner-slide')
      const index = this.active === 'heart' ? 0 : 1
      for (let i = 0; i < partner.length; i++) {
        const items = partner[i].getElementsByClassName('index-partner-slide-item')
        for (let j = 0; j < items.length; j++) {
          const imgs = items[j].getElementsByTagName('img')
          for (let n = 0; n < imgs.length; n++) {
            const _src = imgs[n].getAttribute(`${index === j ? 'data-src2' : 'data-src1'}`)
            imgs[n].setAttribute('src', `${_src}`)
          }
        }
      }
    },
    mouseleave () {
      this.active = null
      const partner = document.getElementsByClassName('index-partner-slide')
      for (let i = 0; i < partner.length; i++) {
        const items = partner[i].getElementsByClassName('index-partner-slide-item')
        for (let j = 0; j < items.length; j++) {
          const imgs = items[j].getElementsByTagName('img')
          for (let n = 0; n < imgs.length; n++) {
            const _src = imgs[n].getAttribute('data-src1')
            imgs[n].setAttribute('src', `${_src}`)
          }
        }
      }
    },
    mouseenterImg () {
      this.mySwiper && this.mySwiper.autoplay.stop()
    },
    mouseleaveImg () {
      this.mySwiper && this.mySwiper.autoplay.start()
    }
  },
  beforeDestroy () { // 页面关闭时清除定时器
    this.mySwiper = null
  }
}
</script>

<style lang="less" scoped>
.pc .index-partner {
  color: #333333;
  padding-top: 90PX;
  .index-partner-title {
    position: relative;
    top: 30%;
    opacity: 0;
    &.transition {
      top: 0;
      opacity: 1;
      transition: top 1s ease, opacity 1s ease;
    }
  }
  .index-partner-type {
    position: relative;
    top: 50%;
    opacity: 0;
    &.transition {
      top: 0;
      opacity: 1;
      transition: top 1.5s ease, opacity 1.5s ease;
    }
  }
  .index-partner-type-item {
    width: 50%;
    height: 276PX;
    // background: #BD1D10;
    background: #00A0E9;
    position: relative;
    color: #ffffff;
    text-align: center;
    margin-top: 40PX;
    &.right {
      // background: #00A0E9;
      background: #BD1D10;
    }
    .index-partner-type-img {
      position: absolute;
      bottom: 10PX;
      transition: all 1s ease;
      max-height: 90%;
      &.img1 {
        left: 0;
      }
      &.img2 {
        right: 0;
      }
    }
    .index-partner-type-title {
      font-size: 20PX;
      line-height: 42PX;
      padding-bottom: 40PX;
      &:not(.en) {
        font-size: 30PX;
        position: relative;
      }
      &::after, &::before {
        content: '';
        position: absolute;
        bottom: 30PX;
        width: 15PX;
        height: 2PX;
        background: #ffffff;
        transition: all 0.3s ease;
      }
      &::after {
        right: calc(50%);
      }
      &::before {
        left: calc(50%);
      }
    }
    &:hover {
      .img1, .img2 {
        transform: scale(0.9, 0.9);
        -webkit-transform: scale(0.9, 0.9);
        -moz-transform: scale(0.9, 0.9);
        -ms-transform: scale(0.9, 0.9);
        -o-transform: scale(0.9, 0.9);
      }
      .index-partner-type-title {
        &::after, &::before {
          width: 3em;
        }
        &.en {
          &::after, &::before {
            width: 50%;
          }
        }
      }
    }
  }
  .index-partner-swiper {
    position: relative;
    top: 50%;
    &.transition {
      top: 0;
      transition: top 1.5s ease;
    }
  }
  .swiper-slide {
    background: #ffffff;
    .index-partner-slide-item {
      width: 50%;
      position: relative;
      .index-partner-slide-img {
        width: 50%;
        // padding: 0 30PX;
        height: 140PX;
        img {
          max-width: calc(100% - 100PX);
          max-height: 140PX;
          // left: 0;
        }
      }
      &:first-child {
        padding-right: 30PX;
        .index-partner-slide-img {
          &:nth-child(even) {
            img {
              // left: 50PX;
            }
          }
        }
      }
      &:last-child {
        padding-left: 30PX;
        .index-partner-slide-img {
          img {
            // left: 50PX;
          }
          &:nth-child(even) {
            img {
              // left: auto;
              // right: 0;
            }
          }
        }
      }
      &:last-child::after {
        position: absolute;
        content: '';
        height: 160PX;
        border-left: 1PX dashed rgba(102, 102, 102, 0.6);
        left: 0;
        top: 68PX;
      }
    }
    &:nth-child(6) {
      .index-partner-slide-item:nth-child(2) {
        .index-partner-slide-img:nth-child(3) {
          img {
          max-width: calc(100% - 150PX);
          max-height: 120PX;
          }
        }
      }
    }
  }
}
</style>
<style lang="less">
.pc .index-partner {
    .index-partner-pagination {
      position: relative;
      top: 10PX;
      .swiper-pagination-bullet {
        background: #D8D8D8;
        margin-right: 34PX;
        width: 12PX;
        height: 12PX;
        opacity: 1;
        &:last-child {
          margin-right: 0;
        }
        &.swiper-pagination-bullet-active {
          background: #00A0E9;
        }
      }
    }
}
</style>

<style lang="less" scoped>
@media screen and (max-height: 500PX) {
  .pc .index-partner {
    padding-top: 60PX;
    .index-partner-swiper {
      top: -10PX;
    }
    .index-partner-type-item {
      height: 120PX;
    }
    .index-partner-swiper {
      margin-top: 0;
      .swiper-slide {
        .index-partner-slide-item {
          .index-partner-slide-img {
            height: 60PX;
            img {
              max-width: calc(100% - 60PX);
              max-height: 60PX;
            }
          }
          &:last-child::after {
            height: 80PX;
            top: 20PX;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 1700PX) and (min-width: 1600PX) {
  .pc .index-partner {
    .index-partner-type {
      top: 50%;
    }
    .index-partner-type-item {
      width: 50%;
      height: 200PX;
      margin-top: 30PX;
      .index-partner-type-img {
        bottom: 10PX;
        height: 80%;
      }
    }
  }
}
@media screen and (max-width: 1600PX) and (min-width: 1400PX) {
  .pc .index-partner {
    .index-partner-type {
      top: 50%;
    }
    .index-partner-type-item {
      width: 50%;
      height: 200PX;
      margin-top: 30PX;
      .index-partner-type-img {
        bottom: 10PX;
        height: 80%;
      }
    }
    .swiper-slide {
      .index-partner-slide-item {
        .index-partner-slide-img {
          height: 100PX;
          img {
            max-width: calc(100% - 100PX);
            max-height: 100PX;
          }
        }
        &:last-child::after {
          height: 100PX;
          top: 48PX;
        }
      }
    }
  }
  .pc.en .index-partner {
    .swiper-slide {
      .index-partner-slide-item {
        .index-partner-slide-img {
          // height: 100PX;
          img {
            max-height: 80PX;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 1400PX) and (min-width: 1366PX)  {
  .index-partner {
    padding-top: 120PX;
    .index-partner-type-item {
      height: 260PX;
      margin-top: 60PX;
      .index-partner-type-img {
        bottom: 10PX;
        height: 80%;
      }
    }
    .swiper-slide {
      .index-partner-slide-item {
        .index-partner-slide-img {
          height: 120PX;
          img {
            max-width: calc(100% - 60PX);
            max-height: 120PX;
          }
        }
        &:last-child::after {
          height: 140PX;
          top: 48PX;
        }
      }
    }
  }
}
@media screen and (max-width: 1366PX) and (min-width: 1280PX) {
  .pc .index-partner {
    padding-top: 90PX;
    .index-partner-type {
      top: 30%;
    }
    .index-partner-type-item {
      width: 50%;
      height: 160PX;
      margin-top: 30PX;
      .index-partner-type-title {
        padding-bottom: 20PX;
        font-size: 26PX;
        &::after, &::before {
          bottom: 14PX;
        }
      }
      .index-partner-type-img {
        bottom: 10PX;
        height: 80%;
      }
    }
    .swiper-slide {
      .index-partner-slide-item {
        .index-partner-slide-img {
          height: 80PX;
          img {
            max-width: calc(100% - 100PX);
            max-height: 100PX;
          }
        }
        &:last-child::after {
          height: 100PX;
          top: 48PX;
        }
      }
    }
  }
}
@media screen and (max-width: 1280PX) {
  .pc .index-partner {
    .index-partner-swiper {
      top: -10PX;
    }
    .index-partner-type-item {
      height: 150PX;
      margin-top: 20PX;
    }
  }
}
@media screen and (width: 1280PX) and (min-height: 660PX) {
  .pc .index-partner {
    padding-top: 90PX;
    .index-partner-type-item {
      margin-top: 40PX;
      height: 170PX;
    }
    .swiper-slide {
      .index-partner-slide-item {
        .index-partner-slide-img {
          height: 100PX;
          img {
            max-width: calc(100% - 100PX);
            max-height: 100PX;
          }
        }
        &:last-child::after {
          height: 100PX;
          top: 48PX;
        }
      }
    }
  }
}
@media screen and (width: 1280PX) and (min-height: 800PX) {
  .pc .index-partner {
    padding-top: 120PX;
    .index-partner-type-item {
      margin-top: 60PX;
      height: 240PX;
    }
    .swiper-slide {
      .index-partner-slide-item {
        .index-partner-slide-img {
          height: 100PX;
          img {
            max-width: calc(100% - 80PX);
            max-height: 120PX;
          }
        }
        &:last-child::after {
          height: 100PX;
          top: 48PX;
        }
      }
    }
  }
}
@media screen and (width: 1280PX) and (max-height: 660PX) {
  .pc .index-partner {
    padding-top: 60PX;
    .index-partner-type-item {
      margin-top: 40PX;
    }
  }
}
@media screen and (max-width: 1152PX) {
  .pc .index-partner {
    .index-partner-type-item {
      height: 200PX;
    }
    .index-partner-swiper {
      margin-top: 10PX;
      .swiper-slide {
        .index-partner-slide-item {
          .index-partner-slide-img {
            height: 120PX;
            img {
              max-width: calc(100% - 60PX);
              max-height: 120PX;
            }
          }
          &:last-child::after {
            height: 140PX;
            top: 48PX;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 1024PX) {
  .pc .index-partner {
    .index-partner-type-item {
      height: 160PX;
    }
    .index-partner-swiper {
      margin-top: 10PX;
      .swiper-slide {
        .index-partner-slide-item {
          .index-partner-slide-img {
            height: 100PX;
            img {
              max-width: calc(100% - 60PX);
              max-height: 100PX;
            }
          }
          &:last-child::after {
            height: 120PX;
            top: 48PX;
          }
        }
      }
    }
  }
}

</style>
